<template>
    <div>
        <div class="skeleton" v-if="skeleton"></div>
        <div v-if="options && filter">
            <div class="drop_block" v-show="!skeleton && options" tabindex="0" @focusout="openDropDown = false">
                <div class="drop_box" @click="openDropDown = !openDropDown">
                    <div class="drop_name">
                        {{ name }}
                        <span class="active_count"> : {{selectedOption}}</span>
                    </div>
                    <div class="drop_arrow">
                        <SvgHeaderSvg v-if="!openDropDown" :type="'down'" />
                        <SvgHeaderSvg v-else :type="'up'" />
                    </div>
                </div>
                <div v-show="openDropDown" class="drop_item" :class="'drop_item_'+name">
                    <ul class="mb-0">
                        <li 
                            v-for="opt in options" :key="opt.value" 
                            :class="{ [opt.icon]: true, 'active': opt.active === 1 }"
                            @click="toggleFilter(opt.value)" 
                        >
                            <span>{{ opt.label }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { cyolistStore }  from '@/stores/cyolist/cyolist';
    const store = cyolistStore();
    const route = useRoute();

    const {name}  = defineProps(['name'])

    const openDropDown = ref(false)
    const skeleton = ref(true)


    const moduleType = route.meta.moduleType
    const moduleSubType = route.meta.moduleSubType 

    const options = computed(() => {
        let option = store.getSettingFilterOptions( moduleSubType , name )
        return option
    })

    const filter = computed(() => store.getSettingFilter(moduleSubType , name ))

    const showOptions= computed(() => {
        return store.getSettingFilterVisibility(moduleSubType , name )
    })

    const selectedOption = computed(() =>{
        const option = options.value.filter( (cv)=>  { return cv.active === 1  })

        if( option.length ){
            return option[0].label
        }else{
             options.value.filter( (cv)=>  { 
                if(cv.value === 'featured'){
                    cv.active = 1
                    return cv.label
                }
              })
        }
        // return 'Featured'
    })
    

    function toggleFilter(value, reset = false) {
      
        store.toggleSettingFilter({ reset:reset, type: moduleSubType , filter: filter.value , option : { value : value }})
        
        if(!['style', 'category'].includes(filter.value.name) || reset === true){
            store.toggleSettingFilterVisibility({ type: moduleSubType , filter: filter.value, reset : true })
        }

        openDropDown.value = false
    }

    const updateSkeletonState = () => {
       
    };

    onMounted(() => {
        if (options.value && filter.value && skeleton.value === true) {
            skeleton.value = false;
        }
    });

    onUpdated(() => {
        if (options.value && filter.value && skeleton.value === true) {
            skeleton.value = false;
        }
    });

</script>

<style scoped>
    .skeleton {
        height: 42px;
        border-radius: 8px;
        background: #eaeaea;
        min-width: 85px;
    }
    .drop_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #c4c4c4;
        border-radius: 8px;
        padding: 8px 12px;
        cursor: pointer;
    }
    .drop_name {
        margin-right: 8px;
        font-size: 14px;
        text-transform: capitalize;
        font-weight: 400;
        color: #212529;
    }
    .drop_name .active_count{
        color: var(--green);
    }
    .drop_item{
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        position: absolute;
        top: calc(100% + 8px);
        left: 0;
        background: #fff;
        z-index: 99;
        /* min-width: 200px; */
        min-width: 130px;
    }
    .drop_item.drop_item_shape {
        width: 315px;
    }
    .title_close {
        padding: 15px 15px 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .title_close .title {
        font-size: 14px;
        text-transform: capitalize;
        font-weight: 700;
        color: #000;
        display: flex;
        align-items: center;
    }
    .eclipse {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 140px;
    }
    .close {
        cursor: pointer;
    }
    ul {
        display: flex;
        flex-wrap: wrap;
        padding: 8px 8px 8px 8px;
    }
    ul li {
        list-style: none;
        width: 100%;
        border-radius: 8px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin: 5px;
        cursor: pointer;
    }
   
    ul li.active span{
        color: var(--green);
        font-weight: 600;
    }
 
  
    .drop_block {
        position: relative;
        /* min-width: 200px; */
    }

    ul li span {
        text-transform: capitalize;
        font-size: 13px;
        font-weight: 400;
        color: #606060;
        display: block;
    }
    .active_label{
        color: var(--green);
    }
    .svg-head {
        height: 17px;
        width: 20px;
    }
    @media(max-width: 767px){
        .drop_block {
            min-width: auto;
        }
        .drop_box {
            border: 0;
            padding: 0;
        }
    }
</style>